import { render, staticRenderFns } from "./userDetail.vue?vue&type=template&id=265199c7&scoped=true"
import script from "./userDetail.vue?vue&type=script&lang=js"
export * from "./userDetail.vue?vue&type=script&lang=js"
import style0 from "./userDetail.vue?vue&type=style&index=0&id=265199c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265199c7",
  null
  
)

export default component.exports